// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',
    "user_name": '',
    "user_name_domain":'',
    "first_name": '',
    "last_name": '',
    "email_address":'',
    "email_address_domain": '',
    "mobile_number":'',
    "mobile_number_code":'',
    "main_number_code":'',
    "main_number":'',
    "npi_number":'',
    "created_day": '',
    "created_month": '',
    "created_year": '',
    "user_id_inverse": '',
    "user_name_inverse": '',
    "first_name_inverse": '',
    "last_name_inverse": '',
    "email_address_inverse":'',
    "mobile_number_inverse":'',
    "main_number_inverse":'',
    "npi_number_inverse":'',
    "created_date_inverse": '',
    "match": false,
    "prosearchApplied": false,

};

const providerSearchSlice = createSlice({
    name: 'providerSearch',
    initialState,
    reducers: {
        setProviderSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetProviderSearch(state) {
            return { ...initialState, prosearchApplied: false }; // Reset state and flag
        },
        setProSearchApplied(state) {
            state.prosearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setProviderSearch, resetProviderSearch,setProSearchApplied } = providerSearchSlice.actions;

export default providerSearchSlice.reducer;